import { InjectionToken } from '@angular/core';
import { PhysicalAddressConfiguration } from '@features/physical-address/types';

export const PHYSICAL_ADDRESS_CONFIG =
  new InjectionToken<PhysicalAddressConfiguration>('PHYSICAL_ADDRESS_CONFIG');
